import {styled} from "@mui/material/styles"
import {MenuItem, ListItemText, ListItemIcon} from "@mui/material"

export const StyledMenuItem = styled(MenuItem)`
    padding: 0.8125rem 0.9375rem 0.8125rem 0.625rem;
`

export const StyledListItemText = styled(ListItemText)`
    margin: 0;
    padding: 0;
    & .MuiListItemText-inset {
        padding-left: 1.875rem;
    }
`

export const StyledListItemIcon = styled(ListItemIcon)`
    min-width: 1.875rem;
`
